<template>
  <div class="promotions-component">
    <s-tabs>
      <s-tab
        name="Промокоды"
        :selected="currentTab === 'promotions'"
      >
        <div class="promocodes-section">
          <h1 class="step-title font-weight-regular">
            Промокоды:
          </h1>
          <div class="button-group d-flex justify-between">
            <v-row
              dense
              class="justify-space-between"
            >
              <v-col sm="5">
                <v-btn
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="stepBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
              <v-col sm="5">
                <v-btn
                  :disabled="currentPopularCode == curBasketPromocode"
                  class="button button-apply"
                  width="100%"
                  color="#4caf50"
                  :loading="loading"
                  @click="setPromocode(currentPopularCode)"
                >
                  <font-awesome-icon icon="check" />
                  Применить
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div class="search-code-section">
            <v-row
              class="justify-space-between"
            >
              <v-col sm="3">
                <v-btn
                  class="button button_no-code text-normalize"
                  :class="{'v-item--active': currentPopularCode == ''}"
                  depressed
                  large
                  width="100%"
                  @click="currentPopularCode = ''"
                >
                  Без промокода
                </v-btn>
              </v-col>
              <v-col sm="9">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model="codeText"
                    hide-details="auto"
                    class="search-field"
                    placeholder="Поиск"
                    flat
                    solo
                  >
                    <template v-slot:append>
                      <v-btn
                        v-if="codeText"
                        small
                        depressed
                        text
                        class="button-clear font-weight-medium"
                        @click="clearCodeText"
                      >
                        <font-awesome-icon icon="times" />
                        Очистить
                      </v-btn>
                    </template>
                  </v-text-field>
                  <!--                  <v-btn
                    class="button-clear font-weight-medium"
                    @click="clearCodeText"
                  >
                    <font-awesome-icon icon="times" />
                    Очистить
                  </v-btn>-->
                </div>
              </v-col>
            </v-row>
          </div>

          <div
            v-if="currentPopularCode && getPopularPromocodeData"
            class="promocode-description"
          >
            <span class="name d-block font-weight-medium">@{{ getPopularPromocodeData.name }}</span>
            <span class="description d-block">{{ getPopularPromocodeData.description }}</span>
            <span
              v-if="getPopularPromocodeData.time_end"
              class="promo-time-end d-inline-block"
            >Действует до: {{ getPopularPromocodeData.time_end }}</span>
          </div>

          <!--          <div class="no-code-section">
            <v-row>
              <v-col sm="3">
                <v-btn
                  class="button text-normalize"
                  :class="{'v-item&#45;&#45;active': currentPopularCode == ''}"
                  depressed
                  large
                  width="100%"
                  @click="currentPopularCode = ''"
                >
                  Без промокода
                </v-btn>
              </v-col>
            </v-row>
          </div>-->

          <div class="popular-codes-section">
            <span class="label">Популярные промокоды:</span>
            <v-row class="promo-codes flex-wrap">
              <template
                v-if="codeText.length <= 1 && !promocodes.length"
                sm="12"
                class="d-flex align-center"
              >
                <v-btn-toggle
                  v-model="currentPopularCode"
                  dense
                  group
                >
                  <v-col
                    v-for="(code, i) in popularPromocodes"
                    :key="i"
                    sm="3"
                  >
                    <v-btn
                      :value="code.id"
                      class="button text-normalize promo-code-item-button"
                      width="100%"
                      depressed
                      :class="{available: code.available}"
                    >
                      {{ code.code }}
                    </v-btn>
                  </v-col>
                </v-btn-toggle>
              </template>
              <template v-if="codeText.length > 1 && promocodes.length">
                <v-btn-toggle
                  v-model="currentPopularCode"
                  dense
                  group
                >
                  <v-col
                    v-for="(code, i) in promocodes"
                    :key="i"
                    sm="3"
                  >
                    <v-btn
                      :value="code.id"
                      class="button text-normalize"
                      width="100%"
                      depressed
                    >
                      {{ code.code }}
                    </v-btn>
                  </v-col>
                </v-btn-toggle>
              </template>
              <v-col
                v-if="codeText.length > 1 && !promocodes.length && !isPromocodesLoading"
                sm="12"
                class="d-flex align-center justify-center"
              >
                <span class="d-block display-3 text-center">
                  Нет подходящих промо-кодов
                </span>
              </v-col>
            </v-row>
          </div>
        </div>
      </s-tab>

      <s-tab
        name="Акции клиента"
        :selected="currentTab === 'discounts'"
      >
        <div class="promotions-section">
          <h1 class="step-title font-weight-regular">
            Акции клиента:
          </h1>
          <div class="button-group d-flex justify-between">
            <v-row
              dense
              class="justify-space-between"
            >
              <v-col sm="5">
                <v-btn
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="stepBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
              <v-col sm="5">
                <v-btn
                  :disabled="!currentPersonalCode"
                  :loading="loading"
                  class="button button-apply"
                  width="100%"
                  color="#F1F3F6"
                  @click="setPromocode(currentPersonalCode)"
                >
                  <font-awesome-icon icon="check" />
                  Применить
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div
            v-if="currentPersonalCode && getPersonalPromocodeData"
            class="promocode-description"
          >
            <span class="name d-block font-weight-medium">@{{ getPersonalPromocodeData.name }}</span>
            <span class="description d-block">{{ getSelectedPromoCodeDescription }}</span>
            <span
              v-if="getPersonalPromocodeData.time_end"
              class="promo-time-end d-inline-block"
            >Действует до: {{ getPersonalPromocodeData.time_end }}</span>

            <div
              v-if="isSelectedBirthdayPersonalPromoCode && !clientBirthdayDate"
              class="pt-2 d-block font-weight-bold"
            >
              Требуется указание даты рождения клиента
            </div>
          </div>

          <div
            v-if="clientBirthdayDate"
            class="pt-2 pb-2 d-block font-weight-bold"
          >
            Дата рождения клиента: {{ clientBirthdayDate }}
          </div>

          <div class="client-promotions">
            <v-btn-toggle
              v-model="currentPersonalCode"
              dense
              group
            >
              <loader
                v-if="isLoadingPersonalPromoCodes"
                absolute
              />
              <v-row class="promo-codes flex-wrap">
                <v-col
                  v-for="(code, i) in personalPromocodes"
                  :key="i"
                >
                  <template v-if="isFoxCoinsPayPromoCode(code)">
                    <v-btn
                      :disabled="code.foxCoinsAvailable < 1"
                      :value="code.id"
                      class="button button-foxcoin text-normalize d-flex"
                      width="100%"
                      depressed
                    >
                      <icon-bonus />
                      <span class="fc-vailable">
                        {{ code.foxCoinsAvailable }}
                      </span>
                      <span class="fc-total">
                        из {{ code.foxCoinsAll }} <br> Сеткоинов
                      </span>
                    </v-btn>
                  </template>

                  <template v-else-if="isFriendsPromoCode(code)">
                    <v-badge
                      v-if="code.availableQuantity > 0"
                      class="fullwidth"
                      :content="code.availableQuantity"
                      :color="'#ff9100'"
                    >
                    </v-badge>
                    <v-btn
                      :disabled="code.availableQuantity < 1"
                      :value="code.id"
                      class="button text-normalize"
                      width="100%"
                      depressed
                    >
                      {{ code.name }}
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-badge
                      v-if="showAvailableQuantity(code)"
                      class="fullwidth"
                      :content="code.availableQuantity"
                      :color="'#ff9100'"
                    >
                    </v-badge>
                    <v-btn
                      :value="code.id"
                      class="button text-normalize"
                      width="100%"
                      depressed
                    >
                      {{ code.name }}
                    </v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-btn-toggle>
          </div>

          <!-- Промокод «День рождения» не применился: у клиента нет даты рождения -->
          <primary-confirm-dialog
            v-model="dialogBirthday"
            max-width="700px"
            title="Укажите день рождения клиента"
            confirm-text="Сохранить дату"
            :loading="isBirthdaySaving"
            :confirm-disabled="!isBirthdayValid"
            @confirm="updateClientBirthday"
          >
            <template #subtitle>
              <!-- Имя и телефон - чтобы оператор видел, чью дату вводит; без имени - только телефон -->
              Дата сохранится в карточке клиента
              <b v-if="clientLabel" style="white-space: nowrap">{{ clientLabel }}</b>
              навсегда, без возможности изменить.
              Отмечаете не его день рождения? Тогда нужна акция <b>«День рождения близкого»</b>.
            </template>

            <template #body>
              <!-- key: при каждом открытии поле создаётся заново, без хвостов прошлого ввода -->
              <step-date-field
                :key="birthdayDialogOpenCount"
                v-model="clientBirthday"
                today-button
                autofocus
                @enter="updateClientBirthday"
              />
              <!-- Возраст по введённой дате: опечатка в годе видна сразу, до запроса -->
              <div
                class="birthday-dialog_hint"
                :class="{ 'birthday-dialog_hint__error': birthdayHint.error }"
              >
                {{ birthdayHint.text }}
              </div>
            </template>
          </primary-confirm-dialog>
        </div>
      </s-tab>
    </s-tabs>

    <promotions-slider />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import Loader from '@/components/loader/Loader.vue'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'
  import IconBonus from '@/components/icons/IconBonus.vue'
  import STabs from '@/components/ui/tabs/STabs.vue'
  import STab from '@/components/ui/tabs/STab.vue'
  import PromotionsSlider from '@/components/order-processing/order-components/promotions/PromotionsSlider.vue'
  import PromoCodeDataService from '@/services/api/PromoCodeDataService'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import StepDateField from '@/components/ui/date/StepDateField.vue'

  const BIRTHDAY_FORMAT = 'DD.MM.YYYY'
  const MAX_CLIENT_AGE = 120

  export default {
    name: 'PromotionsWindow',
    components: { StepDateField, PrimaryConfirmDialog, PromotionsSlider, STab, STabs, IconBonus, Loader },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        currentPopularCode: '',
        currentPersonalCode: '',
        dialogBirthday: false,
        isBirthdaySaving: false,
        birthdayDialogOpenCount: 0,
        // Промокод, который не применился без даты рождения: применяем сам после сохранения даты
        pendingPromoCodeId: null,
        currentTab: 'promotions',
        clientBirthday: '',
        popularPromocodes: [],
        promocodes: [],
        personalPromocodes: [],
        isLoadingPersonalPromoCodes: false,
        codeText: '',
        timeout: null,
        isPromocodesLoading: false,
        loading: false,
      }
    },
    computed: {
      ...mapState({
        client: state => state.newOrder.client,
        basket: state => state.baskets.basket,
      }),
      ...mapGetters({
        isNewOrderPage: 'app/isNewOrderPage',
      }),
      getPopularPromocodeData () {
        if (this.currentPopularCode) {
          const code = this.popularPromocodes.find(code => code.id === this.currentPopularCode)
          if (code) {
            return code
          }
        }
        return null
      },
      getPersonalPromocodeData () {
        if (this.currentPersonalCode) {
          const code = this.personalPromocodes.find(code => code.id === this.currentPersonalCode)
          if (code) {
            return code
          }
        }
        return null
      },
      getSelectedPromoCodeDescription () {
        try {
          if (this.getPersonalPromocodeData) {
            const regex = /(<([^>]+)>)/ig
            return this.getPersonalPromocodeData.description.replace(regex, '')
          }
        } catch (e) {

        }
        return ''
      },
      curBasketPromocode () {
        return this.basket?.promoCode?.promoCode?.code ?? ''
      },
      isSelectedBirthdayPersonalPromoCode () {
        return this.getPersonalPromocodeData?.action === PromoCodeAction.BirthDay
      },
      clientBirthdayDate () {
        return this.basket?.client?.birthday
          ? moment(this.basket.client.birthday).format(BIRTHDAY_FORMAT)
          : ''
      },
      clientLabel () {
        const client = this.basket?.client
        if (!client) return ''
        const phone = client.formattedPhone || client.phone
        if (client.name && phone) return `${client.name} (${phone})`
        return client.name || phone || ''
      },
      // Строгий разбор: «31.02.2000» и «12.13.1990» не проходят, хотя по маске это даты
      parsedBirthday () {
        if ((this.clientBirthday || '').length !== BIRTHDAY_FORMAT.length) {
          return null
        }
        const date = moment(this.clientBirthday, BIRTHDAY_FORMAT, true)
        return date.isValid() ? date : null
      },
      clientAge () {
        return this.parsedBirthday ? moment().diff(this.parsedBirthday, 'years') : null
      },
      isBirthdayValid () {
        return this.clientAge !== null && this.clientAge >= 0 && this.clientAge <= MAX_CLIENT_AGE
      },
      birthdayHint () {
        if ((this.clientBirthday || '').length < BIRTHDAY_FORMAT.length) {
          return { text: 'День, месяц и год, например 14.03.1991', error: false }
        }
        if (!this.parsedBirthday) {
          return { text: 'Такой даты в календаре нет', error: true }
        }
        if (this.clientAge < 0) {
          return { text: 'Дата ещё не наступила', error: true }
        }
        if (this.clientAge > MAX_CLIENT_AGE) {
          return { text: 'Проверьте год рождения', error: true }
        }
        if (this.clientAge === 0) {
          return { text: 'Клиенту меньше года', error: false }
        }
        return { text: `Клиенту ${this.clientAge} ${this.pluralYears(this.clientAge)}`, error: false }
      },
    },
    watch: {
      // Открылись - показываем дату из карточки, если она там уже есть.
      // Закрылись без сохранения - промокод сам не применяем
      dialogBirthday (opened) {
        if (opened) {
          this.birthdayDialogOpenCount++
          this.clientBirthday = this.clientBirthdayDate
        } else if (!this.isBirthdaySaving) {
          this.pendingPromoCodeId = null
        }
      },
      codeText () {
        clearTimeout(this.timeout)
        if (this.codeText.length > 1) {
          this.isPromocodesLoading = true
          this.timeout = setTimeout(() => {
            this.searchPromoCode(this.codeText)
            this.currentPopularCode = this.curBasketPromocode
          }, 500)
        } else {
          this.promocodes = []
          this.currentPopularCode = this.curBasketPromocode
        }
      },
      basket () {
        // this.getPersonalPromocodes()
        this.getReadyForUsePromoCodes()
      },
    },

    created () {
      this.getReadyForUsePromoCodes()
      this.getPersonalPromocodes()
      this.currentPopularCode = this.curBasketPromocode
    },
    methods: {
      pluralYears (n) {
        const mod10 = n % 10
        const mod100 = n % 100
        if (mod10 === 1 && mod100 !== 11) return 'год'
        if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'года'
        return 'лет'
      },
      updateClientBirthday () {
        if (!this.isBirthdayValid || this.isBirthdaySaving) {
          return
        }
        const birthday = this.parsedBirthday.format('YYYY-MM-DD')
        const id = this.basket.client.id
        const data = {
          birthday,
        }

        this.isBirthdaySaving = true
        this.$store.dispatch('clients/editClients', { id, data })
          .then(res => {
            if (res.status !== 200) {
              this.showErrorMessage(res.response.data.message)
              return
            }
            const promoCodeId = this.pendingPromoCodeId
            this.pendingPromoCodeId = null
            this.dialogBirthday = false
            // Дата живёт в basket.client: без перечитывания корзины окно промокодов
            // продолжает показывать «Требуется указание даты рождения»
            this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
            if (promoCodeId) {
              // Дата есть - применяем тот же промокод, его сообщение и будет итогом
              this.setPromocode(promoCodeId)
            } else {
              this.showSuccessMessage('Дата дня рождения сохранена')
            }
          })
          .finally(() => {
            this.isBirthdaySaving = false
          })
      },
      getPromocodes (code = null) {
        /* const payload = {
          limit: 16,
          offset: 0,
          page: 1,
          type: 'all',
          negative: 0,
        }

        if (code) {
          payload.findCode = code
        }

        this.$store.dispatch('promocodes/fetchPromocodesList', payload)
          .then(res => {
            if (res.status === 200) {
              if (!code) {
                this.popularPromocodes = res.data.items
              } else {
                this.promocodes = res.data.items
              }
            }
          }).finally(() => {
            this.isPromocodesLoading = false
          }) */
      },
      async getReadyForUsePromoCodes () {
        this.isPromocodesLoading = true

        try {
          const basketId = this.basket?.id
          this.popularPromocodes = await PromoCodeDataService.getReadyForUseItems({ basketId })
          console.log(this.promocodes)
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.isPromocodesLoading = false
      },

      async searchPromoCode (text) {
        this.isPromocodesLoading = true

        const payload = {
          limit: 16,
          offset: 0,
          page: 1,
          type: 'all',
          negative: 0,
          findCode: text,
        }

        try {
          const res = await this.$store.dispatch('promocodes/fetchPromocodesList', payload)
          this.promocodes = res.data.items
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.isPromocodesLoading = false
      },
      getPersonalPromocodes () {
        const payload = {
          clientId: this.basket.client.id,
          basketId: this.basket.id,
        }
        this.isLoadingPersonalPromoCodes = true
        this.$store.dispatch('promocodes/fetchPersonalPromocodesList', payload)
          .then(res => {
            if (res.status === 200) {
              this.personalPromocodes = res.data.items
            }
          })
          .finally(() => {
            this.isLoadingPersonalPromoCodes = false
          })
      },
      setPromocode (promoCodeId) {
        this.loading = true
        const data = {
          promoCodeId,
        }
        const id = this.basket.id
        this.$store.dispatch('baskets/updateBasket', { data, id }).then(res => {
          if (res.status === 200) {
            this.showSuccessMessage('Промокод добавлен')
            this.$store.dispatch('baskets/fetchSingleBasket', id)
            this.stepBack()
          } else {
            // Нет даты рождения - вместо алерта сразу окно ввода даты
            if (res.response?.data?.data?.reason === 'notBirthday') {
              this.pendingPromoCodeId = promoCodeId
              this.dialogBirthday = true
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      clearCodeText () {
        if (this.codeText) {
          this.codeText = ''
          this.promocodes = []
          // this.getPromocodes()
        }
      },
      stepBack () {
        if (this.isNewOrderPage) {
          this.$store.commit('newOrder/togglePromotionsWindow', false)
        } else {
          this.$store.commit('fastOrder/togglePromotionsWindow', false)
        }
      },
      isFoxCoinsPayPromoCode (code) {
        return code && code.action === PromoCodeAction.FoxCoinPay
      },
      isFriendsPromoCode (code) {
        return code && code.action === PromoCodeAction.FriendPercent
      },
      showAvailableQuantity (code) {
        return code.availableQuantity > 1
      },
    },
  }
</script>

<style lang="less">
  .promotions-component {
    .ps {
      height: 100%;
    }
  }
</style>

<style lang="less" scoped>
  .promotions-component {

    background-color: #fafafa;
    font-size: 14px;

    .media-xl({
      font-size: 12px;
      //padding-top: 30px;
    });

    .promocode-description {
      margin-bottom: 32px;
      .name {
        font-size: 1.42em;
        margin-bottom: 12px;
      }
      .description {
        font-size: 1.14em;
      }
      .promo-time-end {
        margin-top: 5px;
        padding: 5px 8px;
        font-size: 1.14em;
        background-color: #f1f3f6;
        border-radius: 5px;
      }
    }

    .label {
      display: block;
      margin-bottom: 14px;
      font-size: 1.42em;
      line-height: 1.1;
    }

    .button {
      height: 80px;
      background-color: @color-secondary !important;
      border-radius: 10px;

      &,button_no-code {
        font-size: 1.7em;
      }

      &.button-foxcoin {
        svg {
          margin-right: 10px;
        }

        .fc-total {
          font-size: 14px;
          line-height: 1;
          text-align: left;
        }
        .fc-vailable {
          margin-right: 10px;
          font-size: 26px;
          font-weight: 500;
        }
      }
    }

    ::v-deep {
      &.v-item--active {
        background-color: @color-primary !important;
        color: #ffffff;
      }
    }

    .available {
      box-shadow: 0 0 0 1px @color-success !important;
      //box-shadow: 0 0 0 4px rgba(255, 145, 1, 0.26);
        //border: 1px solid #4caf50 !important;
        //outline: 1px #4caf50;
        ::v-deep {
          &.v-item--active {
            box-shadow: none !important;
          }
        }
    }

    .button-group {
      margin-bottom: 21px;

      .button {
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;

        svg {
          margin-right: 8px;
        }
      }

      .button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }

      .button-apply {
        background-color: @color-success !important;
        color: #ffffff;

        svg {
          .fill-svg(#ffffff);
        }
      }
    }

    .promocodes-section {
      .button-group {
        margin-bottom: 30px;
      }

      .search-code-section {
        margin-bottom: 30px;

        .search-field {
          &.v-input--is-focused {
            &::v-deep {
              .v-input__slot {
                border: 2px solid @color-primary;
              }
            }
          }

          &::v-deep {
            .v-input__slot {
              height: 68px;
              background-color: #f1f3f6;
              border-radius: 10px;
              border: 2px solid #f1f3f6;
              .media-xl({
                height: 80px;
              });
            }
          }
        }

        .button-clear {
          height: 61px;
          font-size: 1.07em;
          border-radius: 10px;
          margin-left: 33px;
          padding: 0 60px;
          background-color: #f1f3f6;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
          margin-right: -11px;

          svg {
            width: 19px;
            height: 19px;
            margin-right: 5px;
            .fill-svg(@color-error);
          }

          .media-xl({
            height: 76px;
          });
        }
      }

      .no-code-section {
        margin-bottom: 20px;

        .button {
          font-size: 1.28em;
        }
      }

      .popular-codes-section {
        margin-bottom: 30px;

        .promo-codes {
          min-height: 103px;
          ::v-deep {
            .v-item-group {
              display: flex;
              flex-wrap: wrap;
            }
          }
          .button {
            font-size: 1.7em;
            line-height: 1;
          }
        }
      }
    }

    ::v-deep {
      .v-item-group {
        width: 100%;
      }
    }

    .promotions-section {
      .button-group {
        margin-bottom: 51px;
      }

      .client-promotions {
        margin-bottom: 26px;

        .col {
          position: relative;
          flex-basis: 25%;
          flex-grow: 0;
        }

        ::v-deep {
          .v-item-group {
            width: 100%;
          }
          .v-badge  {
            position: absolute;
            right: 20px;
            top: 18px;
            z-index: 100;
          }
        }

        .button {
          font-size: 24px;
          line-height: 18px;
        }
      }

      .fox-promotions {
        .promotion {
          cursor: default;
          max-width: 358px;
          height: 100%;
          background-color: @color-secondary;
          border-radius: 30px;
          text-align: center;
          overflow: hidden;

          span {
            font-size: 22px;
            line-height: 23px;
          }
        }
      }
    }

    // Компактный десктоп: заголовок ближе к вкладкам, отступы вокруг поиска меньше.
    // Блок стоит последним: его правила той же специфичности, что и обычные выше
    .media-compact-pc({
      ::v-deep .s-tabs-headers {
        margin-bottom: 12px;
      }

      .promocodes-section {
        .button-group,
        .search-code-section {
          margin-bottom: 14px;
        }

        // «Без промокода» по ширине подписи - в колонку на четверть ряда она
        // не помещалась; поиск занимает остаток
        .search-code-section {
          .row > .col:first-child {
            flex: 0 0 auto;
            width: auto;
            max-width: none;
          }

          .row > .col:last-child {
            flex: 1 1 0;
            min-width: 0;
            max-width: none;
          }

          // ширину 100% кнопке задаёт инлайновый стиль от пропа width;
          // высота как у поля поиска
          .button_no-code {
            width: auto !important;
            height: 68px;
            padding: 0 20px;
          }
        }
      }
    });
  }
</style>

<style lang="less">
// Окно дня рождения: не scoped, диалог рендерится вне корня компонента.
// Поле и панель выбора даты стилизует StepDateField, здесь только подсказка
.primary-confirm-dialog {
  // Высота зарезервирована: текст подсказки меняется, окно не прыгает
  .birthday-dialog_hint {
    min-height: 22px;
    margin: 10px 0 0 4px;
    font-size: 15px;
    line-height: 22px;
    color: #6b6b6b;
    transition: color 0.15s ease-out;

    &__error {
      color: @color-error;
    }
  }
}
</style>
